import { render, staticRenderFns } from "./editProductGroup.vue?vue&type=template&id=0876e28d"
import script from "./editProductGroup.vue?vue&type=script&lang=js"
export * from "./editProductGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports